// JsFromRoutes CacheKey 39e11e501dcd51f1decddbde6335f30c
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  dismiss: /* #__PURE__ */ definePathHelper('post', '/dismissible_notices/dismiss'),
}
